module.exports = __webpack_public_path__ + "static/media/clg_acharya_logo.3673ea16.png";